import styled from '@emotion/styled';
import {colors, fontSize, sizes} from 'patient-ping-remedy/packages/theme';

export const TealContainer = styled.section`
  background-color: ${colors.teal1};
  margin-top: ${sizes.xSmall};
`;

export const HeaderButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 5rem;
  gap: ${sizes.xSmall};
  padding: ${sizes.xSmall} ${sizes.large};
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  color: ${colors.charcoal};

  &:focus-visible {
    outline: 2px solid ${colors.blue4};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const HeaderLeft = styled.span`
  display: flex;
  align-items: center;
  gap: ${sizes.small};
`;

export const LeadIn = styled.span`
  font-size: ${fontSize.standard};
  color: ${colors.teal5};
`;

export const Chevron = styled.span`
  display: inline-flex;
  align-items: center;
`;

export const Body = styled.div`
  padding: 0 ${sizes.small} ${sizes.small};
`;

export const EventCard = styled.div`
  background-color: ${colors.white};
  border-radius: ${sizes.xSmall};
  padding: ${sizes.small};

  & + & {
    margin-top: ${sizes.small};
  }
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${sizes.xSmall};
`;

const segmentBase = `
  font-size: ${fontSize.small};
  line-height: 1.8rem;
`;

export const TypeSegment = styled.span`
  ${segmentBase};
  color: ${colors.charcoal};
`;

export const DateSegment = styled.span`
  ${segmentBase};
  color: ${colors.gray5};
`;

export const ViewNotesSegment = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${sizes.xSmall};
  margin-left: auto;
  font-size: ${fontSize.small};
  line-height: 1.8rem;
`;

export const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.3rem 0.8rem;
  border-radius: 0.4rem;
  background-color: ${colors.gray2};
  color: ${colors.charcoal};
  font-size: ${fontSize.small};
  line-height: 1.4rem;
`;

export const ViewNotesButton = styled.button`
  padding: 0;
  color: ${colors.blue4};
  background: none;
  border: none;
  cursor: pointer;
  font-size: ${fontSize.standard};
  text-decoration: underline;

  &:focus-visible {
    outline: 2px solid ${colors.blue4};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;
